import {
  CUSTOM,
  WEEK,
  MONTH,
  DAY,
  QUARTER,
  TODAY,
  THISWEEK,
  THISMONTH,
  THISQUARTER,
  THISYEAR,
  YESTERDAY,
  LAST7DAYS,
  LASTWEEK,
  LAST30DAYS,
  LASTMONTH,
  LASTQUARTER,
  LASTYEAR,
} from '../../timePeriods';

export const getOptions = t => [
  {
    name: t('previousTimePeriod'),
    id: 'previous_time',
    value: 'previous_time',
  },
  {
    name: t('previousYear'),
    id: 'previous_year',
    value: 'previous_year',
  },
  {
    name: t('customPeriod'),
    id: 'custom_range',
    value: 'custom_range',
  },
];

export const timePeriodsCustom = t => [
  {
    name: t('customTimePeriod'),
    id: CUSTOM,
    value: CUSTOM,
  },
  {
    name: t('dayTimePeriod'),
    id: DAY,
    value: DAY,
  },
  {
    name: t('weekTimePeriod'),
    id: WEEK,
    value: WEEK,
  },
  {
    name: t('monthTimePeriod'),
    id: MONTH,
    value: MONTH,
  },
  {
    name: t('quarterTimePeriod'),
    id: QUARTER,
    value: QUARTER,
  },
];

export const timePeriodsCurrent = t => [
  {
    name: t('todayTimePeriod'),
    id: TODAY,
    value: TODAY,
  },
  {
    name: t('weekTimePeriod'),
    id: THISWEEK,
    value: THISWEEK,
  },
  {
    name: t('monthTimePeriod'),
    id: THISMONTH,
    value: THISMONTH,
  },
  {
    name: t('quarterTimePeriod'),
    id: THISQUARTER,
    value: THISQUARTER,
  },
  {
    name: t('yearTimePeriod'),
    id: THISYEAR,
    value: THISYEAR,
  },
];

export const timePeriodsLast = t => [
  {
    name: t('yesterdayTimePeriod'),
    id: YESTERDAY,
    value: YESTERDAY,
  },
  {
    name: t('7daysTimePeriod'),
    id: LAST7DAYS,
    value: LAST7DAYS,
  },
  {
    name: t('weekTimePeriod'),
    id: LASTWEEK,
    value: LASTWEEK,
  },
  {
    name: t('30daysTimePeriod'),
    id: LAST30DAYS,
    value: LAST30DAYS,
  },
  {
    name: t('monthTimePeriod'),
    id: LASTMONTH,
    value: LASTMONTH,
  },
  {
    name: t('quarterTimePeriod'),
    id: LASTQUARTER,
    value: LASTQUARTER,
  },
  {
    name: t('yearTimePeriod'),
    id: LASTYEAR,
    value: LASTYEAR,
  },
];
